import './main.css'
import { useEffect, useState } from 'react';
import createPaymentLink from '../createCheckout/main';
import callAPI from '../fetch/main';
import { Button, Divider, Switch, Radio, Tooltip, Collapse, message, Alert, Badge } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';


function Coupons({ showINR }) {


    let cpns = {
        "usd": [
            { "name": "Legend Yearly", "value": "Extra $20", "description": "Offer for 1st year on legend yearly plan, Only for beta users.", "code": "LEGENDBETAUSER", "expires": "31-DEC-2024" },
            { "name": "Legend Monthly", "value": "Extra $2", "description": "Offer every month for next 3 month on legend yearly plan, Only for beta users.", "code": "LEGENDBETAUSERMON", "expires": "31-DEC-2024" },
            { "name": "Growth Yearly", "value": "Get Extra 10%", "description": "Offer for 1st year on growth yearly plan, Only for beta users.", "code": "GROWTHBETAUSER", "expires": "31-DEC-2024" },
        ],

        "inr": [
            { "name": "Legend Yearly", "value": "Extra ₹1,600*", "description": "Offer for 1st year on legend yearly plan, Only for beta users.", "code": "LEGENDBETAUSER", "expires": "31-DEC-2024" },
            { "name": "Legend Monthly", "value": "Extra ₹160*", "description": "Offer every month for next 3 month on legend yearly plan, Only for beta users.", "code": "LEGENDBETAUSERMON", "expires": "31-DEC-2024" },
            { "name": "Growth Yearly", "value": "Get Extra 10%", "description": "offer for 1st year on growth yearly plan, Only for beta users.", "code": "GROWTHBETAUSER", "expires": "31-DEC-2024" },
        ]
    }


    return (
        <div>
            <h3 style={{ fontWeight: '500' }}>Offers only for Beta users:</h3>
            <div className='coupons-list'>
                {
                    cpns[showINR ? "inr" : "usd"].map((cpn) =>
                        <div className='coupon'>
                            <div className='coupon-header'>
                                <p>{cpn.name}</p>
                            </div>
                            <div className='coupon-body'>
                                <div className='price-n-code'>
                                    <p className='coupon-value'>{cpn.value}</p>

                                    <Tooltip title="Click to copy the coupon code">
                                        <Button
                                            backgroundColor="primary"
                                            style={{ color: '#1677ff', borderColor: '#1677ff' }}
                                            type="dashed"
                                            onClick={async () => {
                                                try {
                                                    await navigator.clipboard.writeText(cpn.code);
                                                    message.success("Copied to clipboard!")
                                                } catch (error) {
                                                    console.error('Failed to copy text: ', error);
                                                }
                                            }}
                                        >{cpn.code}</Button>
                                    </Tooltip>
                                </div>
                                <div>
                                    <p>{cpn.description}</p>
                                    <p className='cpn-expiry-date'>Expires at - {cpn.expires}</p>
                                </div>
                            </div>
                        </div>
                    )
                }

            </div>
        </div>
    )
}


function FreePlan() {

    return (
        <div className='partner-program'>
            <h2 className='pp-title'>Join our affiliate Program and get unlimited automation for upto 6 month free.</h2>

            <div className='partner-program-flex'>
                <div className='partner-card black-bg'>
                    <h1>Get 3 Month unlimited automation access free!</h1>
                    <h2>Referal Commision:</h2>
                    <ul>
                        <li>Everytime someone uses your code to subscribe to plan, you take 60% Commision on first month.</li>
                    </ul>
                    <h2>Deliverables:</h2>
                    <ul>
                        <li>1 x Instagram Reels posted to your Instagram account (Minimum 20 seconds)</li>
                    </ul>
                    <h2>Criteria:</h2>
                    <ul>
                        <li>Tag InstantDM in post and mention in caption</li>
                        <li>Add InstantDM as collaborator</li>
                        <li>Reel must remain active</li>
                        <li>No faceless content</li>

                    </ul>
                    <h2>Follower requirement:</h2>
                    <ul>
                        <li>Instagram: Minimum 25,000 followers</li>
                    </ul>
                    <h2>Bonus:</h2>
                    <ul>
                        <li>If the video reaches 1,00,000+ views within 1 weeks of posting, you will receive 6 months of unlimited automation for free.</li>
                    </ul>
                </div>
                <div className='partner-card'>
                    <h1>Get 3 Month Growth plan access free!</h1>
                    <h2>Referal Commision:</h2>
                    <ul>
                        <li>Everytime someone uses your code to subscribe to plan, you take 60% Commision on first month.</li>
                    </ul>
                    <h2>Deliverables:</h2>
                    <ul>
                        <li>1 x Instagram Reels posted to your Instagram account (Minimum 20 seconds)</li>
                    </ul>
                    <h2>Criteria:</h2>
                    <ul>
                        <li>Tag InstantDM in post and mention in caption</li>
                        <li>Add InstantDM as collaborator</li>
                        <li>Reel must remain active</li>
                        <li>No faceless content</li>
                    </ul>
                    <h2>Follower requirement:</h2>
                    <ul>
                        <li>Instagram: Minimum 8,000 followers</li>
                    </ul>
                    <h2>Bonus:</h2>
                    <ul>
                        <li>If the video reaches 50,000+ views within 1 weeks of posting, you will receive 6 months of unlimited automation plan for free.</li>
                    </ul>
                </div>
            </div>

            <h2>How to join</h2>

            <ul>Send a DM to our IG accounts <a target='_blank' href='https://www.instagram.com/code_with_ssk/'>Instagram : Code with SSK</a> or <a target='_blank' href='https://www.instagram.com/instant.dm/'>Instagram : Instant DM</a> </ul>

        </div>
    )
}



function ShowPlans(props) {

    let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    let default_currency = user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta" ? "inr" : "usd"
    const [showINR, setShowINR] = useState((user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta") ? true : false)

    const monthOptions = [{ "value": 'Monthly', "label": "Monthly" }, { "value": 'Yearly', "label": "Yearly" }];
    const [monthChange, setMonthChange] = useState('Yearly')

    let plans = [
        // {
        //     "id": "free", "yearly_id": "free", "name": "Free", "price": "0", "inr_price": "0", "yearly_price": "0", "yearly_inr_price": "0",
        //     "description": "Launch your automation journey with 1500 free automations, giving you a head start on exploring our features and achieving your goals.",
        //     "au_count": "1,500",
        //     "features": ["1,500 Automations Monthly",  "Link Unlimited Posts", "Remove Branding", "Multiple reply comments","Normal Support"]
        // },
        {
            "id": "566420", "yearly_id": "566421", "name": "Growth", "price": "$5", "inr_price": "₹449", "yearly_price": "$50", "yearly_inr_price": "₹4,499", "og_yearly_price": "$60", "og_yearly_inr_price": "₹5,388",
            "description": "Balanced automation and features for budget-conscious creators, maximizing value for your investment.",
            "au_count": "10,000", "features": ["10,000 Comment to DM Automations", "Upto 500 new comment replies per hour", "Link Unlimited Posts", "Welcome message", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Normal Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$65", "inr": "₹5,525.00+" }, { "name": "LinkDM", "usd": "$19", "inr": "₹1,634.00+" },]
        },
        // 560840
        {
            "id": "566422", "yearly_id": "566423", "name": "Legend", "price": "$8.99", "inr_price": "₹699", "yearly_price": "$89.99", "yearly_inr_price": "₹6,999", "og_yearly_price": "$96", "og_yearly_inr_price": "₹8,388",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "Unlimited (500 New automation / hour)", "features": ["Unlimited Comment to DM automations", "Upto 500 new comment replies per hour", "Follow for link", "Welcome message", "Link Unlimited Posts", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$515", "inr": "₹44,290.00+" }, { "name": "LinkDM", "usd": "$99", "inr": "₹8,514.00+" },]
        },

        {
            "id": "000003", "inr_monthly_regular": "₹1,499", "monthly_regular": "$18", "yearly_id": "0000031", "name": "Legend Pro", "price": "$12", "inr_price": "₹999", "yearly_price": "$120", "yearly_inr_price": "₹9,999", "og_yearly_price": "$144", "og_yearly_inr_price": "11,988",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "Unlimited (1500 New automation / hour)", "features": ["Unlimited Comment to DM automations", "Upto 1500 new comment replies per hour", "Follow for link", "Welcome message", "Link Unlimited Posts", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$515", "inr": "₹44,290.00+" }, { "name": "LinkDM", "usd": "$99", "inr": "₹8,514.00+" },],
            "recommended": true
        },

        {
            "id": "428337", "inr_monthly_regular": "₹4,499", "monthly_regular": "$50", "yearly_id": "428338", "name": "Trendsetter", "price": "$25", "inr_price": "₹1,999", "yearly_price": "$250", "yearly_inr_price": "₹19,999", "og_yearly_price": "$300", "og_yearly_inr_price": "₹23,988",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "Unlimited (No hourly limit) + Account Saftey", "features": ["Unlimited Comment to DM automations", "Maximum allowed by instagram new comment replies per hour", "Automate post sent to your DM", "Follow for link", "Welcome message", "Higher Rate Limit", "Auto comment reply turn-off", "Auto comment reply turn-on", "Auto Trending mode detector", "Auto trending mode activator", "Auto smart welcome message", "DM Queues", "Auto Failure detection", "Auto overload handler", "Auto smart slow down mode(Reply Delay)", "Link Unlimited Posts", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$1,235", "inr": "₹1,06,210.00+" }, { "name": "LinkDM", "usd": "$99", "inr": "₹8,514.00+" },],

        },
    ]


    let multi_plans = [
        // {
        //     "id": "free", "yearly_id": "free", "name": "Free", "price": "0", "inr_price": "0", "yearly_price": "0", "yearly_inr_price": "0",
        //     "description": "Launch your automation journey with 1500 free automations, giving you a head start on exploring our features and achieving your goals.",
        //     "au_count": "1,500",
        //     "features": ["1,500 Automations Monthly",  "Link Unlimited Posts", "Remove Branding", "Multiple reply comments","Normal Support"]
        // },
        {
            "id": "201", "yearly_id": "2011", "name": "Multiplex Lite", "price": "$6", "inr_price": "₹499", "yearly_price": "$60", "yearly_inr_price": "₹4,999", "og_yearly_price": "$72", "og_yearly_inr_price": "₹5,988",
            "description": "Balanced automation and features for budget-conscious creators, maximizing value for your investment.",
            "au_count": "10,000 per Account X 2", "features": ["Maximum 2 account","10,000 Comment to DM Automations per account", "Upto 500 new comment replies per hour", "Link Unlimited Posts", "Welcome message", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Normal Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$125", "inr": "₹10,875+" }, { "name": "LinkDM", "usd": "$19", "inr": "₹1,653+" },]
        },
        // 560840
        {
            "id": "202", "yearly_id": "2021", "name": "Multiplex Pro", "price": "$8", "inr_price": "₹699", "yearly_price": "$80", "yearly_inr_price": "₹6,999", "og_yearly_price": "$96", "og_yearly_inr_price": "₹8,388",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "15,000 per Account X 2", "features": ["Maximum 2 account","15,000 Comment to DM Automations per account", "Follow for link", "Welcome message", "Link Unlimited Posts", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$165", "inr": "₹14,355+" }, { "name": "LinkDM", "usd": "$19", "inr": "₹1,653+" },]
        },

        {
            "id": "203", "inr_monthly_regular": "₹1,499", "monthly_regular": "$18", "yearly_id": "2031", "name": "Multiplex Max", "price": "$12", "inr_price": "₹999", "yearly_price": "$120", "yearly_inr_price": "₹9,999", "og_yearly_price": "$144", "og_yearly_inr_price": "11,988",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "30,000 per Account x 3", "features": ["Maximum 3 account","30,000 Comment to DM Automations per account", "Follow for link", "Welcome message", "Link Unlimited Posts", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$315", "inr": "₹27,405+" }, { "name": "LinkDM", "usd": "$19", "inr": "₹1,653+" },],
            "recommended": true
        },
        {
            "id": "204", "inr_monthly_regular": "₹8,699", "monthly_regular": "$99", "yearly_id": "2041", "name": "Multiplex Ultra", "price": "$69", "inr_price": "₹5999", "yearly_price": "$699", "yearly_inr_price": "₹59,999", "og_yearly_price": "$839", "og_yearly_inr_price": "₹72,000",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "3,00,000 per Account x 6", "features": ["Maximum 6 account","3,00,000 Comment to DM Automations per account", "Follow for link", "Welcome message", "Link Unlimited Posts", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$7235", "inr": "₹6,29,000+" }, { "name": "LinkDM", "usd": "$99", "inr": "₹8,613+" },],
            
        },
    ]

    const getId = (id, year_id, selected) => {
        let temp_id = id
        if (selected == "Yearly") {
            temp_id = year_id
        }
        console.log("=====", id, year_id, temp_id, selected)
        return temp_id
    }

    const PlanCard = ({ plan, price_currency }) => {

        // alert(plan.id == "566420" && default_currency !="inr")
        if(plan.id === "566420" && !showINR){
            return
        }

        return (
            <div key={plan.id} className='price-card'>
                {/* {plan.id == props.currentPlan && <span className='current-plan'>Current Plan</span>} */}

                <div className='row' style={{ marginTop: '20px' }}>
                    <p className='plan-name'>{plan.name}  </p>
                    <div>
                        <p className='plan-price'>{showINR ? plan.inr_price : plan.price}</p>
                        {plan.inr_monthly_regular && <p className='plan-regular-price'>{showINR ? plan.inr_monthly_regular : plan.monthly_regular}</p>}
                    </div>
                </div>

                {/* {
                    (plan.id != "free" && monthChange == "Yearly") &&
                    <div className='row'>
                        <p className='plan-limit dis-price'>{showINR ? plan.yearly_inr_price : plan.yearly_price} <br /> <span className='og-price' >{showINR ? plan.og_yearly_inr_price : plan.og_yearly_price} </span></p>
                        <p className='plan-limit-desc'>Total Payable</p>
                    </div>
                } */}
                <div className='row'>
                    <p className='plan-limit'>{plan.au_count}</p>
                    <p className='plan-limit-desc'>Automation monthly</p>
                </div>

                {/* { <p className='plan-description'>{plan.description}</p>} */}


                {

                    <Button size='large' type='default'
                        onClick={() => {


                            createPaymentLink(monthChange == "Yearly" ? plan.yearly_id :
                                plan.id, default_currency, props.messageApi, props.setPaymentLinkLoading, props.setPaymentLinkData)

                            let user_detail = JSON.parse(localStorage.getItem("userData"))
                            let igid = localStorage.getItem("ig_id")

                            const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
                            const CHAT_ID = '776956029';
                            const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
                            let tele_message = `[TRYING TO SUBSCRIBE] - user ${user_detail.emailid}  - tried subscription for - ${plan.name}-${monthChange} , IG ID = ${igid} , user id = ${user_detail.user_id} , currency = ${showINR}`
                            let data = {
                                chat_id: CHAT_ID,
                                text: tele_message
                            };


                            fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(data)
                            })
                                .then(response => response.json())
                                .then(data => {
                                    console.log('Message sent successfully:', data);
                                })
                                .catch(error => {
                                    console.error('Error sending message:', error);
                                });

                        }}

                        style={{
                            width: '90%', margin: '0 auto', marginTop: '20px',
                            borderRadius: '4px'
                        }}> {plan.id == props.currentPlan ? "Current Plan" : "Upgrade to this plan"}</Button>
                }
                <Divider />

                {
                    plan.comp_price != undefined && plan.comp_price.map((comp, index) =>

                        <Alert
                            message={`Same Plan Cost ${showINR ? comp.inr : comp.usd} in ${comp.name} every month.`}
                            type="warning"
                            title={`${comp.name} Cost ${showINR ? comp.inr : comp.usd}`}
                            style={{ marginTop: '20px' }} />

                    )
                }
                <Divider />

                {
                    plan.features.map((feature) => <div className='feature'> ✓ {feature} </div>)
                }
            </div>
        )
    }

    const [selectedCategory, setSelectedCategory]= useState([...plans])

    let free_plan = ["1,500 Automations Monthly", "Link Unlimited Posts", "Remove Branding", "Multiple reply comments", "Normal Support", "Upto 500 new comment replies per hour"]



      
    return (

        <div>
            <div>
                <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'space-between', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                    <h2>InstantDM Pricing</h2>
                    {default_currency != "usd" && <p className='price-inr'><Switch value={showINR} checkedChildren="₹" unCheckedChildren="$" onChange={() => setShowINR(!showINR)} /> </p>}
                </div>

            </div>
            {/* <Collapse style={{ marginBottom: '20px' }} items={[{
                key: '0',
                label: 'Get upto 6 Months Unlimited automation for free & Earn for Referral',
                children: <FreePlan />,
            },]} />

             { (localStorage.getItem("founding_user") == "true" || localStorage.getItem("founding_user") == true) && <Collapse style={{ marginBottom: '20px' }} items={[{
                key: '0',
                label: 'Special discount for beta users.',
                children: <Coupons showINR={showINR} />,
            },]} />
            } */}
            <div>
                <div style={{ width: '100%', display: 'flex',"gap":"20px", flexDirection:"column", 'alignItems': 'center', justifyContent: 'center', marginBottom: '10px' }}>

                {/* <Radio.Group
                        options={[{
                            "label":"Unlimited Automation",
                            "value":0
                        },{
                            "label":"Multi Account Support",
                            "value":1
                        }]}
                        onChange={({ target: { value } }) => setSelectedCategory(value == 0 ? [...plans] : [...multi_plans])}
                        defaultValue={0}
                        optionType="button"
                        buttonStyle="solid"
                /> */}
                
                    <Radio.Group
                        options={monthOptions}
                        onChange={({ target: { value } }) => setMonthChange(value)}
                        value={monthChange}
                        optionType="button"
                        buttonStyle="solid"
                    />

                </div>


            </div>
            <div className='tm-free'>
                   { monthChange == "Yearly" && <p>You will get 2 months free by choosing yearly plan 🎉.</p> }
                </div>

            <div className='plans-list'>

                {
                    selectedCategory.map((plan) =>

                        
                        <PlanCard plan={plan} price_currency={default_currency} />

                    )
                }
                <div>


                </div>




            </div>

            <div>
                <Alert
                    message={("free" == props.currentPlan || "free" == props.currentPlan) ? `Always Free Plan (Current Plan)` : "Always Free Plan"}
                    description=<div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "20px" }}>{free_plan.map((item, index) => <p>{item},</p>)}</div>
                    type="info"
                    showIcon
                />
            </div>

            {
                showINR && <p style={{ color: 'rgba(0,0,0,.4' }}>*INR price may change based on usd to inr conversion rate, the payment will be collected in USD.</p>
            }

        </div>

    )

}

export default ShowPlans;
